var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-wrap" }, [
    _c("span", { staticClass: "background", on: { click: _vm.closePopup } }, [
      _vm._v(">")
    ]),
    _vm._v(" "),
    _c("article", [
      _c("a", { staticClass: "exit", on: { click: _vm.closePopup } }, [
        _c("span"),
        _vm._v(" "),
        _c("span")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.data.content) } }),
        _vm._v(" "),
        _vm.buttonCancel
          ? _c("a", { staticClass: "button", on: { click: _vm.closePopup } }, [
              _vm._v("Cancel")
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550eaadd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550eaadd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/PopupModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-550eaadd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/PopupModal.vue
// module chunks = 1